import React, { useState, useEffect } from 'react';
import '../../styles.css';
import '../style.css';
import { Tooltip } from '@material-ui/core';
import DocumentViewer from '../../../../../resuableComponents/docViewer/index';
import ReactPlayer from 'react-player';
import MsViewer from '../../../../../resuableComponents/docViewer/msViewer';
import { useIntl } from 'react-intl';

const Preview = ({ handleClosePreview, classes, fname, furl, ftype }) =>
{
	const [ fileType, setFileType ] = useState('');
	const intl = useIntl();

	useEffect(() =>
	{
		if (fname)
		{

			const imageExtensions = [ '.jpg', '.jpeg', '.png', '.gif' ];
			const videoExtensions = [ '.mp4', '.mov' ];
			const audioExtensions = [ '.mp3' ];
			const pdfExtensions = [ '.pdf' ];
			const msExtensions = [ '.doc', '.docx', '.ppt', '.pptx', '.xlsx', '.xls' ];

			const extension = `.${ fname.split('.').pop()
				.toLowerCase()}`;

			if (imageExtensions.includes(extension))
			{
				setFileType('Image');
			}
			else if (videoExtensions.includes(extension))
			{
				setFileType('Video');
			}
			else if (audioExtensions.includes(extension))
			{
				setFileType('Audio');
			}
			else if (pdfExtensions.includes(extension))
			{
				setFileType('Pdf');
			}
			else if (msExtensions.includes(extension))
			{
				setFileType('Ms');
			}
			else
			{
				setFileType('Unknown type');
			}
		}
	}, [ fname ]);

	const handleDownload = () =>
	{
		fetch(furl)
			.then((response) =>
			{
				if (!response.ok)
				{
					throw new Error('Network response was not ok');
				}

				return response.blob();
			})
			.then((blob) =>
			{
				const url = window.URL.createObjectURL(blob);

				const a = document.createElement('a');

				a.style.display = 'none';
				a.href = url;
				a.download = fname;
				document.body.appendChild(a);
				a.click();
				window.URL.revokeObjectURL(url);
				document.body.removeChild(a);
			})
			.catch((error) =>
			{
				console.error('Error downloading file', error);
			});
	};

	return (
		<div className={classes.previewWindow}>
			<div className='flexCol pdngSM fullH aEnd'>
				<div className='flexRow aCntr pdngXS'>
					<Tooltip
						title={intl.formatMessage({
							id             : 'back',
							defaultMessage : 'Back'
						})}
						placement='bottom'
					>
						<div className='flexAutoRow pointer'>
							<div className='backIcon'>
								<img src='/icons/whiteBack.svg' alt='close' className='img' onClick={handleClosePreview} />
							</div>
						</div>
					</Tooltip>
					<div className='flexMinWidthRow pdngHSM'>
						<span className='wTxt'>{fname}</span>
					</div>
					<Tooltip
						title={intl.formatMessage({
							id             : 'filesharing.download',
							defaultMessage : 'Download'
						})} placement='bottom'
					>
						<div className='flexAutoRow pointer' onClick={handleDownload}>
							<div className='downLoadWhiteIcon'>
								<img src='/icons/whiteDownload.svg' alt='close' className='img' />
							</div>
						</div>
					</Tooltip>
				</div>
				<div className='previewElememt'>
					{fileType === 'Pdf' && furl && <DocumentViewer url={furl} fileType={ftype}/>}
					{fileType === 'Ms' && furl && <MsViewer url={furl} fileType={ftype}/>}
					{fileType === 'Video' && (
						<div className='previewVideo videoParent'>
							<ReactPlayer
								url={furl}
								className={classes.videoFile}
								type='video/mp4/mov'
								controls
								width={'100%'}
								height={'100%'}
								autoPlay
							/>
						</div>
					)}
					{fileType === 'Image' && (
						<img className={classes.imgFile1} src={furl} alt={fname} />
					)}
					{fileType === 'Audio' && (
						<div className='flexMinWidthCol pdngSM aCntr jCntr'>
							<audio controls>
								<source src={furl} type='audio/mpeg' />
								Your browser does not support the audio element.
							</audio>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Preview;